exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-147f9e14]{background-color:#fb8c00;color:#fff;font-weight:700}", ""]);

// exports
